// extracted by mini-css-extract-plugin
export default {"button":"ThumbsDownButton_button__82-Oe"};